'use client';

import { FC } from 'react';
import { useNotificationManager } from 'modules/shop/notificationManager/hooks';
import { NotificationPosition } from 'modules/shop/notificationManager/types';
import { Notification } from './Notification';

export const Notifications: FC = () => {
  const { notifications, removeNotification } = useNotificationManager();
  const filteredList = notifications.filter(
    (a) => a.position == NotificationPosition.BOTTOM,
  );

  return !filteredList.length
    ? null
    : filteredList.map(({ id, payload }) => (
        <Notification key={id} onClose={() => removeNotification(id)}>
          {payload.name}
        </Notification>
      ));
};
